<template>
  <v-app-bar
    app
    dark
    :src="getAssetImg('/assets/header_ndk0xg.webp')"
    elevation="8"
    class="navbar-glass"
  >
    <template v-slot:img="{ props }">
      <v-img
        v-bind="props"
        gradient="to bottom, rgba(25, 118, 210, 0.1), rgba(21, 101, 192, 0.9)"
      ></v-img>
    </template>
    <v-spacer></v-spacer>
    <v-app-bar-title>
      <span class="navbar-title font-weight-black text-h4">Premium Quality Drywall</span>
    </v-app-bar-title>
    <v-spacer></v-spacer>
    <template v-slot:extension>
      <v-tabs centered>
        <v-tab :to="{name: 'home'}" class="font-weight-bold nav-tab">
          <v-icon left small>mdi-home</v-icon>
          Home
        </v-tab>
        <v-tab :to="{name: 'about'}" class="font-weight-bold nav-tab">
          <v-icon left small>mdi-information</v-icon>
          About Us
        </v-tab>
        <v-tab :to="{name: 'services'}" class="font-weight-bold nav-tab">
          <v-icon left small>mdi-tools</v-icon>
          Services
        </v-tab>
        <v-tab :to="{name: 'licenses'}" class="font-weight-bold nav-tab">
          <v-icon left small>mdi-certificate</v-icon>
          Licenses
        </v-tab>
        <v-tab :to="{name: 'gallery'}" class="font-weight-bold nav-tab">
          <v-icon left small>mdi-image-multiple</v-icon>
          Gallery
        </v-tab>
        <v-tab :to="{name: 'contact'}" class="font-weight-bold nav-tab">
          <v-icon left small>mdi-phone</v-icon>
          Contact Us
        </v-tab>
      </v-tabs>
    </template>
  </v-app-bar>
</template>

<script>
export default {
  components: {},
  name: "NavBarFull",
};
</script>

<style scoped>
.navbar-glass {
  backdrop-filter: blur(10px);
}

.navbar-title {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
}

.nav-tab {
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
}

.nav-tab:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-2px);
}

.nav-tab::before {
  opacity: 0.05;
}

.nav-tab:hover::before {
  opacity: 0.15;
}

#logoContainer {
  width: 100px;
}

.headline {
  cursor: pointer;
}
</style>
